import { DateAsString } from '../types/generated-types';

const PERIOD_COMMA_SPACE_REGEX = /[,.\s]/g;

export const formatNumberString = (value: string): string =>
    // Formatterer tall ved å sette inn space mellom tall, f.eks:
    // 1000000 => 1 000 000 | 10000 => 10 000 | etc
    value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const formatNumber = (value: number): string => {
    return formatNumberString(value.toString());
};

const formatDate = (options: Intl.DateTimeFormatOptions, date: DateAsString) => {
    return new Intl.DateTimeFormat('nb-NO', options).format(new Date(date));
};

export const formatShortDate = (date: DateAsString): string => {
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return formatDate(options, date);
};

const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

export const formatLongDate = (date: DateAsString) => {
    const options: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return capitalize(formatDate(options, date));
};

export const formatKontonummer = (value: string): string => {
    return value.replace(PERIOD_COMMA_SPACE_REGEX, '');
};

export const toValidNumberString = (value: string): string =>
    value
        .split('')
        .filter((char) => ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(char))
        .join('');

const formatMobiltelefonnummer = (tlf: string): string =>
    `${tlf.substring(0, 3)} ${tlf.substring(3, 5)} ${tlf.substring(5)}`;

const formatFasttelefonnummer = (tlf: string): string =>
    `${tlf.substring(0, 2)} ${tlf.substring(2, 4)} ${tlf.substring(4, 6)} ${tlf.substring(6)}`;

export const formatTelefonnummer = (telefonnummer: string) => {
    const telefonnummerWithoutSpaces = telefonnummer.replace(/\s/g, '');

    if (telefonnummerWithoutSpaces.length !== 8) {
        return telefonnummer;
    }
    if (telefonnummerWithoutSpaces[0] === '4' || telefonnummerWithoutSpaces[0] === '9') {
        return formatMobiltelefonnummer(telefonnummerWithoutSpaces);
    }
    return formatFasttelefonnummer(telefonnummerWithoutSpaces);
};
